import React, { Component } from 'react';
import { connect } from 'react-redux';
import './HeadingMain.css';
import {MAIN_HEAD_1, MAIN_HEAD_2} from './../../Data/Data';

export class HeadingMain extends Component {

    
    render() {
        return (
            <div id="home" className="jumbotron mx-2 mt-2 bg-transparent border-bottom">
                <div className="row">
         
                    <img className="img-width-head" src="Images/BPL_inline.png"></img>
                 
                </div>
                <p className="body-font res-l-indent">
            {MAIN_HEAD_1} <br/><br/>
            {MAIN_HEAD_2}
        </p>
                
                
            </div>
        )
    }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(HeadingMain)
